import ScrollAnimate from './scrollAnimate'
import { ScrollNotify } from './scroll'
import { setTimeout } from 'timers';

export default class VueScroll {
    run() { 
        this.notify.run();
    }
    stop() { 
        this.notify.stop();
    }
    constructor(vue, config = {}) { 
        let withScroll = config.withScroll;

        this.delay = config.delay;

        var self = this;

        let doms = document.getElementsByClassName('scroll-animate') 
        var config = { 
            doms,
            offsetDom: document.body,
            onenter(param) { 
                self.animateDom(param, vue);
            }
        };

        for(var index in doms){
            //先隐藏，滑动到的时候再显示
            if(doms.hasOwnProperty(index)){
                doms[index].classList.add('hide')
            }
        }

        if(withScroll){
            this.notify = new ScrollAnimate(config)            
        }else{
            this.notify = new ScrollNotify(config)
        }
    }
    animateDom(param, vue) { 
        if(!param.down) return;

        var self = this;
        
        var dom = param.ele.dom;

        if(param.ele.notFirst) return;
            param.ele.notFirst = true;

        let delay = dom.getAttribute('data-animate-delay') || this.delay;

        if(delay) {
            (function(vue, dom, delay){
                setTimeout(()=>{
                    self.animateDomConfig(vue,dom)
                }, delay)
            })(vue, dom, delay)
        }else{
            this.animateDomConfig(vue, dom)
        }
    }
    /**
     * 根据data-信息
     */
    animateDomConfig(vue, dom) {

        dom.classList.remove('hide')

        var children = [];

        children.push(dom);
        //遍历dom 寻找data-animate属性 放入class中
        while(children.length > 0) { 
            dom = children.pop();

            if(dom.children && dom.children.length > 0)
                for(var i in dom.children) {
                    if(dom.children.hasOwnProperty(i))
                        children.push(dom.children[i]); 
                }

                if(!dom.getAttribute) continue;

                this.animateTransition(vue, dom)
        }
    }
    animateTransition(vue, dom){
        let classAttr = dom.getAttribute('data-animate-class');
        if(classAttr) {
            //去除隐藏
            dom.classList.add(classAttr);
        }

        let methodAttr = dom.getAttribute('data-animate-method');
        if(methodAttr) {
            vue[methodAttr]();
        }
    }
}



// WEBPACK FOOTER //
// ./src/api/animateDom.js


// WEBPACK FOOTER //
// ./src/api/animateDom.js